<template>
  <div
    id="tabulator"
    ref="tableRef"
    class="mt-5 table-report table-report--tabulator profile-member-table"
    :data-test="`${tableName}-data-table`"
  />
</template>

<script setup>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
// import axios from "axios";
import { useRoute, useRouter } from 'vue-router'
import { useStore } from "vuex";



const props = defineProps({
  dataArrayTable: {
    type: Array,
  },
  paginationSize: {
    type: Number,
    default: 10,
  },
  paginationSizeArray: {
    type: Array,
    default: () => [10, 20, 50, 100],
  },
  dataArray: {
    type: Array,
  },
  apiUrl: {
    type: String,
  },
  tableName: {
    type: String,
    default: "init"
  },
  routerName:{
    type: String
  },
  apiParams:{
    type: Object
  },
  totalList:{
    type: Number
  },
  methodRequest:{
    type: String
  },
  stackedMobile: {
    type: Boolean,
    default: false,
  }
})
const emits = defineEmits(["rowClicked"])
const tableRef = ref();
const tabulator = ref();
const router = useRouter()
const route = useRoute()
const MOBILE_BREAKPOINT = 1005;

const normalizedColumns = () =>
  (props.dataArrayTable || []).map((column) => ({
    hozAlign: "left",
    headerHozAlign: "left",
    ...column,
  }));
const getTableElement = () => tableRef.value;
const getColumnLabel = (title = "") => String(title).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
const getColumnLabels = () => props.dataArrayTable.reduce((labels, column) => {
  if (column?.field) {
    labels[column.field] = getColumnLabel(column.title);
  }

  return labels;
}, {});
const setCellDataLabels = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  const labels = getColumnLabels();

  tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
    const field = cell.getAttribute("tabulator-field");
    const label = labels[field] || "";

    if (label) {
      cell.setAttribute("data-label", label);
    }
  });
};
const showAllColumns = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-col").forEach((col) => {
    if (col.style.display == "none") {
      col.style.display = "inline-block";
      col.setAttribute("hide", "true");
    }
  });
};
const syncCellWidths = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-col").forEach((col) => {
    tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
      if (
        cell.getAttribute("tabulator-field") ==
        col.getAttribute("tabulator-field")
      ) {
        cell.style.width = cell.style.width
          ? cell.style.width
          : cell.style.minWidth;
      }
    });
  });
};
const showAllCells = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
    cell.style.display = "inline-flex";
    cell.style.removeProperty("height");
  });
};
const applyDefaultMobileLayout = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-col").forEach((col) => {
    if (col.hasAttribute("hide")) {
      tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
        if (
          col.style.display == "inline-block" &&
          cell.getAttribute("tabulator-field") ==
            col.getAttribute("tabulator-field")
        ) {
          cell.style.display = "none";
          cell.style.removeProperty("height");
        }
      });
    } else {
      tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
        if (
          col.style.display == "none" &&
          cell.getAttribute("tabulator-field") ==
            col.getAttribute("tabulator-field")
        ) {
          cell.style.display = "none";
          cell.style.removeProperty("height");
        }
      });
    }
  });
};
const setupRowCollapse = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-row").forEach((row) => {
    row.classList.add("row-collapsible");

    const firstCell = row.querySelector(".tabulator-cell");

    if (!firstCell || firstCell.querySelector(".row-collapse-toggle")) {
      return;
    }

    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "row-collapse-toggle";
    toggle.innerHTML = `<i data-feather="chevron-down"></i>`;
    toggle.addEventListener("click", (event) => {
      event.stopPropagation();
      row.classList.toggle("row-expanded");
    });

    firstCell.appendChild(toggle);
  });

  feather.replace({
    "stroke-width": 2,
  });
};
const syncResponsiveLayout = () => {
  const tableElement = getTableElement();

  if (!tableElement || !tabulator.value) {
    return;
  }

  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

  tableElement.classList.toggle("tabulator-mobile-stacked-mode", props.stackedMobile && isMobile);
  setCellDataLabels();

  if (!isMobile) {
    showAllColumns();
    syncCellWidths();
    showAllCells();
    return;
  }

  if (props.stackedMobile) {
    showAllColumns();
    showAllCells();
    setupRowCollapse();
    return;
  }

  applyDefaultMobileLayout();
};
const initTabulator = () => {
  tabulator.value = new Tabulator(tableRef.value, {
    locale: "th-th",
    langs: {
      "th-th": {
        pagination: {
          page_size: "แสดง",
        },
      },
    },
    data: props.dataArray,
    rowClick: function(e, row){
      emits("rowClicked", row._row.data)
    },
    pageLoaded: function(e, row){
      if(window.innerWidth > MOBILE_BREAKPOINT){
        tabulator.value.redraw();
        // document.querySelectorAll(".tabulator-col").forEach((col)=>{
        //   if(col.style.display == 'none'){
        //     col.style.display = 'inline-block' 
        //     col.setAttribute("hide","true")
        //   }
        //   //check cell field name equal to header column and set width
        //   document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
        //     if(cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field')){
        //       cell.style.width = cell.style.width ? cell.style.width : cell.style.minWidth
        //     }
        //   })
        // })
        // document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
        //   if(cell.style.display == 'none')
        //     cell.style.display = 'inline-flex'
        // })
      }
      syncResponsiveLayout();
    },
    layout:"fitColumns",
    responsiveLayout:'collapse',
    //virtual DOM positions rows using its own precomputed height offsets, independent of the
    //browser's layout flow - that breaks the collapse/expand toggle (row never visually grows)
    //since pagination is already local/small, there's no real perf need to keep virtualization
    virtualDom: false,
    pagination: 'local',
    headerSort:true,
    paginationSize: props.paginationSize,
    paginationSizeSelector: props.paginationSizeArray,
    cellVertAlign:"middle",
    placeholder:"ไม่มีข้อมูล",
    footerElement:`<span class="mb-1">ทั้งหมด <span class="totalList">${props.dataArray.length}</span> รายการ</span>`,
    columns: normalizedColumns(),
    columnHeaderSortMulti:true,
    renderComplete() {
      syncResponsiveLayout();
      feather.replace({
        'stroke-width': 2
      })
    }
  })
}
const testSort = () =>{
  let ee = tabulator.value.getSorters()
}

const reInitOnResizeWindow = () => {
  syncResponsiveLayout();

  window.addEventListener("resize", () => {
    tabulator.value.redraw();
    syncResponsiveLayout();
    feather.replace({
      "stroke-width": 1.5,
    });
  });
};
// Redraw table onresize
// const reInitOnResizeWindow = () => {
//   //when load
//   if(window.innerWidth > MOBILE_BREAKPOINT){
//     // document.querySelectorAll(".tabulator-col").forEach((col)=>{
//     //   if(col.style.display == 'none'){
//     //     col.style.display = 'inline-block'
//     //     col.setAttribute("hide","true")
//     //   }
//     //   //check cell field name equal to header column and set width
//     //   document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
//     //     if(cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field')){
//     //       cell.style.width = cell.style.width ? cell.style.width : cell.style.minWidth
//     //     }
//     //   })
//     // })
//     // document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
//     //   if(cell.style.display == 'none')
//     //     cell.style.display = 'inline-flex'
//     // })
//   }

//   window.addEventListener("resize", () => {
//     tabulator.value.redraw();
//     if(window.innerWidth <= 1005){
//       document.querySelectorAll(".tabulator-col").forEach((col)=>{
//         if(col.hasAttribute('hide')){
//           document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
//             if(col.style.display == 'inline-block' && (cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field'))){
//               cell.style.display = 'none'
//               cell.style.removeProperty('height')
//             }
//           })
//         }
//         else{//when resize from small to large screen
//           document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
//             if(col.style.display == 'none' && (cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field'))){
//               cell.style.display = 'none'
//               cell.style.removeProperty('height')
//             }
//           })
//         }
//         })
//     }
//     else{
//       // always display every column
//       document.querySelectorAll(".tabulator-col").forEach((col)=>{
//         if(col.style.display == 'none'){
//           col.style.display = 'inline-block'
//           col.setAttribute("hide","true")
//         }
//       })
//       document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
//           cell.style.display = 'inline-flex'
//           cell.style.removeProperty('height')
//       })
//     }
//     feather.replace({
//       "stroke-width": 1.5,
//     });
//   });
// };

onMounted(() => {
  initTabulator()
  reInitOnResizeWindow()
})



</script>
<style lang="scss">
.tabulator .tabulator-row .tabulator-responsive-collapse{
  display: none;
}
/* .tabulator .tabulator-header .tabulator-headers .tabulator-col, .tabulator .tabulator-row .tabulator-cell{
  display: inline-block !important;
  min-width: 80px;
  width: 200px;
} */
.tabulator .tabulator-row .tabulator-responsive-collapse td strong {
  font-weight: 600 !important;
}
.tabulator-cell[tabulator-field=full_name]{
  font-weight: 600;
}
.row-collapse-toggle {
  display: none;
}
@media only screen and (max-width:1005px){
  .tabulator {
    .tabulator-tableHolder {
      // overflow: unset !important;
      .tabulator-table{
        white-space: normal !important;
        width: 100%;
        .tabulator-row .tabulator-responsive-collapse{
          display: block;
        }
      }
    }
  }

  .tabulator.tabulator-mobile-stacked-mode.profile-member-table {
    border: 0;
    background: transparent;

    .tabulator-header {
      display: none;
    }

    .tabulator-tableHolder {
      overflow-x: hidden;

      .tabulator-table {
        width: 100% !important;
      }
    }

    .tabulator-row {
      display: block;
      overflow: visible;
      background: #ffffff;
      border: 1px solid #e5e7eb;
      margin-bottom: 15px;
      border-radius: 10px;
      //Tabulator sets an inline height on the row for its layout engine, calculated
      //independently of the collapse toggle - force auto so expanding actually grows the box
      height: auto !important;
    }

    .tabulator-row .tabulator-cell {
      display: flex !important;
      align-items: flex-start;
      justify-content: flex-start !important;
      text-align: left !important;
      gap: 0.75rem;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: auto !important;
      padding: 0.875rem 1rem;
      white-space: normal !important;
      border-right: 0;
      // border-bottom: 1px solid #f1f5f9;
    }

    //collapsed by default - only the first cell shows until the toggle expands the row
    //scoped to .row-collapsible (added only by setupRowCollapse) since .tabulator-mobile-stacked-mode
    //is shared with datatable/index.vue's unscoped styles and must not affect its rows
    .tabulator-row.row-collapsible .tabulator-cell:not(:first-child) {
      display: none !important;
    }

    .tabulator-row.row-collapsible.row-expanded .tabulator-cell:not(:first-child) {
      display: flex !important;
    }

    .tabulator-row.row-collapsible .tabulator-cell:first-child {
      position: relative;
      padding-right: 2.5rem;
    }

    .row-collapse-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0.75rem;
      right: 1rem;
      width: 1.5rem;
      height: 1.5rem;
      border: 0;
      background: transparent;
      color: #6b7280;
      cursor: pointer;
      transition: transform 0.2s ease;

      svg {
        width: 1rem;
        height: 1rem;
      }
    }

    .tabulator-row.row-expanded .row-collapse-toggle {
      transform: rotate(180deg);
    }

    .tabulator-row .tabulator-cell.tabulator-align-center {
      justify-content: center !important;
      text-align: center !important;
    }

    .tabulator-row .tabulator-cell.tabulator-align-right {
      justify-content: flex-end !important;
      text-align: right !important;
    }

    .tabulator-row .tabulator-cell::before {
      content: attr(data-label);
      flex: 0 0 42%;
      max-width: 42%;
      font-weight: 600;
      word-break: break-word;
    }

    .tabulator-row .tabulator-cell:last-child {
      border-bottom: 0;
    }

    .tabulator-row .tabulator-cell > * {
      min-width: 0;
    }

    .tabulator-row .tabulator-responsive-collapse {
      display: none !important;
    }

    //the row itself clips overflow for the rounded-card look on mobile, which cuts off the
    //t-tooltip text (position: absolute) no matter which side it opens on - let the row's
    //clipping relax only while a tooltip inside it is actually being hovered, so the card
    //shape is unaffected at rest and desktop (outside this stacked-mobile class) is untouched
    .tabulator-row:has(.t-tooltip:hover) {
      overflow: visible;
    }
  }
}


</style>
